import React from "react";
import {
    createMuiTheme,
    ThemeProvider,
    responsiveFontSizes,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Link} from "@reach/router";
const AllData = React.lazy(() => import("./AllData"));
const TableData = React.lazy(() => import("./TableData"));

let theme = createMuiTheme({
    palette: {
        background: {
            paper: "#101010",
        },
        type: "dark",
    },
});
theme = responsiveFontSizes(theme);

const Home = () => {
    return (
        <ThemeProvider theme={theme}>
            <React.Suspense
                fallback={
                    <Box component="section" m={2}>
                        <Paper
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "16px",
                                padding: "10px",
                            }}
                        >
                            <CircularProgress />
                        </Paper>
                    </Box>
                }
            >
                <Box component="section" m={2}>
                    <Grid container direction="column">
                        <Grid item>
                            <header>
                                <Typography
                                    style={{
                                        color: "#fff",
                                        marginBottom: "16px",
                                    }}
                                    variant="h4"
                                >
                                    <Link
                                        style={{
                                            textDecoration: "none",
                                        }}
                                        to="/"
                                    >
                                        COVID-19 DASHBOARD
                                    </Link>
                                </Typography>
                            </header>
                        </Grid>
                        <Grid item xs={12}>
                            <AllData url="https://disease.sh/v3/covid-19/all" />
                        </Grid>
                        <Grid item xs={12} style={{marginTop: "16px"}}>
                            <Paper style={{padding: "10px"}}>
                                <Typography variant="h4">
                                    Country Wise Data
                                </Typography>
                            </Paper>
                            <TableData />
                        </Grid>
                    </Grid>
                </Box>
            </React.Suspense>
        </ThemeProvider>
    );
};

export default Home;
